// Frequently asked questions. Rendered on /faq and referenced elsewhere.
// OWNER: confirm every answer marked "(EDIT)" before launch — the numbers,
// timelines, and policies below are reasonable starting points, not promises.

export const FAQ = [
  {
    q: 'How long does it take to get my map?',
    a: 'Every map is made to order. After you approve your proof, production and shipping typically take about X weeks. We will confirm the exact timeline before you order. (EDIT)',
  },
  {
    q: 'How much is shipping and where do you ship?',
    a: 'We currently ship within the United States, with free standard shipping included. International shipping may be available on request. Confirm your shipping regions, carriers, and any surcharges here. (EDIT)',
  },
  {
    q: 'What places can you make? Is my town covered?',
    a: 'If you can point to it on a map, we can almost certainly build it. Terrain comes from public USGS, NOAA, and OpenStreetMap data covering the U.S. and most of the world. Very remote areas may have coarser data — note any coverage limits here. (EDIT)',
  },
  {
    q: 'What material is it, and how deep is the relief?',
    a: 'Maps are 3D printed in durable PLA and finished by hand. The vertical relief is exaggerated so the terrain reads clearly on a wall. Confirm the exact material, finish options, mounting, and relief/exaggeration details here. (EDIT)',
  },
  {
    q: 'How does the proof and approval process work?',
    a: 'Nothing prints until you say so. We build the final render from survey data and email it to you first. You review the crop, scale, and legend, and request changes if needed. Only after you approve does the map go on the printer. (EDIT)',
  },
  {
    q: 'What is your return and remake policy?',
    a: 'Because each map is custom and printed once, we focus on getting it right before anything prints — that is what the proof step is for. If your order arrives damaged or is not what you approved, we will remake or refund it. Confirm the exact return window and conditions here. (EDIT)',
  },
  {
    q: 'Can I send it as a gift?',
    a: 'Yes. You can add a custom second legend line (a name, date, or message), ship directly to the recipient, and time it to an occasion. Confirm gift-note limits, gift shipping, and lead times for dated occasions here. (EDIT)',
  },
  {
    q: 'What sizes and prices are available?',
    a: 'The current format is an 8 by 8 inch relief map, made to order. Pricing and any additional sizes are shown in the studio. Confirm sizes and prices here. (EDIT)',
  },
];

export default FAQ;
